import { useMemo } from 'react';
import { usePublishingFeed } from 'hooks/usePublishingFeed';

export const useIsShareEntireScreen = () => {
  const { videoStream } = usePublishingFeed('screenshare');

  return useMemo(() => {
    const track = videoStream?.getVideoTracks?.()[0];

    const displaySurface = track?.getSettings?.().displaySurface;

    return displaySurface === 'monitor' || displaySurface === 'screen';
  }, [videoStream]);
};
